module.exports = __webpack_public_path__ + "static/team-e56380a4df96d21702d25b09fe63c2e5.png";